import { ff } from '@atlassian/jira-feature-flagging';

// <pyamada>
export const isLongTasksRefactorEnabled = () => ff('jsw.long-tasks-refactor');
// </pyamada>
